// components/BrickWallSegment.jsx
import React, { useMemo } from 'react';
import { useGLTF } from '@react-three/drei';

// Map each variant to its GLB path
const WALL_PATHS = {
  long:   '/stageAssets/stage2/scene/Stage2Exterior-BrickwallLong.glb',
  short:  '/stageAssets/stage2/scene/Stage2Exterior-BrickwallShort.glb',
  corner: '/stageAssets/stage2/scene/Stage2Exterior-BrickwallCorner.glb',
  column: '/stageAssets/stage2/scene/Stage2Exterior-BrickwallColumn.glb',
};

export function BrickWallSegment({ variant = 'long', ...props }) {
  const path = WALL_PATHS[variant] ?? WALL_PATHS.long;
  const { scene } = useGLTF(path);

  // 👇 Clone so each BrickWallSegment gets its *own* object
  const wall = useMemo(() => (scene ? scene.clone(true) : null), [scene]);
  if (!wall) return null;

  return (
    <primitive
      object={wall}
      castShadow
      receiveShadow
      {...props} // position, rotation, scale, etc.
    />
  );
}

// Preload all wall pieces
Object.values(WALL_PATHS).forEach((p) => useGLTF.preload(p));
